import { render, staticRenderFns } from "./PantallaEmbarcando.vue?vue&type=template&id=2dd267f4&scoped=true&lang=true&"
import script from "./PantallaEmbarcando.vue?vue&type=script&lang=js&"
export * from "./PantallaEmbarcando.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd267f4",
  null
  
)

export default component.exports